"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _PanelItems = require("../PanelItems");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

function getIntegrationPanel(props) {
  var title = props.title,
      isInstalled = props.isInstalled,
      imageFromName = props.imageFromName,
      imageToName = props.imageToName,
      isSettingEnabled = props.isSettingEnabled,
      toggleLabel = props.toggleLabel,
      communityArticleLink = props.communityArticleLink,
      description = props.description,
      additionalHelpText = props.additionalHelpText,
      integrationStatus = props.integrationStatus,
      customClass = props.customClass;
  return {
    title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderTitle, {
      isInstalled: isInstalled,
      storedIsSettingEnabled: isSettingEnabled,
      title: title,
      imageFromName: imageFromName,
      imageToName: imageToName
    }),
    body: (0, _preact.h)(IntegrationPanelBody, {
      isInstalled: isInstalled,
      isSettingEnabled: isSettingEnabled,
      toggleLabel: toggleLabel,
      communityArticleLink: communityArticleLink,
      description: description,
      additionalHelpText: additionalHelpText,
      integrationStatus: integrationStatus
    }),
    customClass: "integration__panel ".concat(customClass || '')
  };
}

var IntegrationPanelBody = function IntegrationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      isSettingEnabled = _ref.isSettingEnabled,
      communityArticleLink = _ref.communityArticleLink,
      description = _ref.description,
      additionalHelpText = _ref.additionalHelpText,
      toggleLabel = _ref.toggleLabel,
      integrationStatus = _ref.integrationStatus;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)("div", {
    className: "panel-body-instructions"
  }, description), isInstalled && (0, _preact.h)(_PanelItems.ToggleWithLabel, {
    label: toggleLabel,
    isToggleEnabled: isSettingEnabled,
    onSettingChanged: function onSettingChanged() {}
  }), isInstalled && isSettingEnabled && integrationStatus, isSettingEnabled ? (0, _preact.h)("div", {
    className: "help-text-wrapper"
  }, " \uD83D\uDE4C ", (0, _preact.h)("span", {
    className: "text--bold"
  }, "What\u2019s next:"), " ", additionalHelpText, " ") : null, (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "Learn more about this integration",
    url: communityArticleLink,
    isExternalLinkForToggle: false
  }));
};

var _default = getIntegrationPanel;
exports.default = _default;